import axios from '@/core/axios'

import { CMS } from 'stoux-shared-types/models/cms'

export default class CMSService {
    static async list() {
        const { data } = await axios.get<{ resources: CMS[] }>('/cms')
        return data
    }
}
